import { render } from "./CreateLesson.vue?vue&type=template&id=b3ac7606"
import script from "./CreateLesson.vue?vue&type=script&lang=js"
export * from "./CreateLesson.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__